import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Dialog,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import YoutubeThubmnail from "../../../components/images/YouTube-Thumbnail.webp";

export default function LeadCaptureVideoPopup({ open, onClose }) {
  const [playVideo, setPlayVideo] = useState(false);
  const isSmallScreen = window.innerWidth < 600;

  const [gclid, setGclid] = useState('');

  const [formError, setFormError] = useState('');

  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    website: window.location.href.slice(0, 250),
    description: window.location.href.includes("full-stack-web-development")
      ? "Full Stack Web Development"
      : window.location.href.includes("devops-and-cloud-training-online")
      ? "DevOps and Cloud with GenAI Master Program"
      : "DevOps and Cloud with GenAI Job Ready Program",
  });

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });

  useEffect(() => {
    const urlGclid = new URLSearchParams(window.location.search).get("gclid");
    if (urlGclid) {
      localStorage.setItem('gclid', urlGclid);
      setGclid(urlGclid);
    } else {
      const storedGclid = localStorage.getItem('gclid');
      setGclid(storedGclid);
    }
  }, []);

  const validateFirstName = (value) => (!value ? 'First name is required' : '');
  const validateLastName = (value) => (!value ? 'Last name is required' : '');
  const validateEmail = (value) => {
    if (!value) return 'Email is required';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return 'Invalid email address';
    return '';
  };
  const validatePhone = (value) => {
    if (!value) return 'Phone number is required';
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(value)) return 'Phone number must be 10 digits';
    return '';
  };

  const handleChange = (e, field) => {
    const { value } = e.target;
    setFormValues({
      ...formValues,
      [field]: value,
    });

    let error = '';
    switch (field) {
      case 'firstName': error = validateFirstName(value); break;
      case 'lastName': error = validateLastName(value); break;
      case 'email': error = validateEmail(value); break;
      case 'phone': error = validatePhone(value); break;
      default: break;
    }

    setErrors({
      ...errors,
      [field]: error,
    });
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const firstNameError = validateFirstName(formValues.firstName);
    const lastNameError = validateLastName(formValues.lastName);
    const emailError = validateEmail(formValues.email);
    const phoneError = validatePhone(formValues.phone);

    if (firstNameError || lastNameError || emailError || phoneError) {
      setErrors({
        firstName: firstNameError,
        lastName: lastNameError,
        email: emailError,
        phone: phoneError,
      });

      setFormError(firstNameError || lastNameError || emailError || phoneError);
      return;
    } else {
      document.forms['WebToLeads774394000000902061'].submit();
    }
  };

  const inputStyle = {
    background: "#ffffff",
    borderRadius: "12px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
      "& fieldset": { borderColor: "#e5e7eb" },
      "&:hover fieldset": { borderColor: "#c7c9d1" },
      "&.Mui-focused fieldset": { borderColor: "#6a3df0" },
    },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={isSmallScreen ? "md" : "lg"}
      PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}
    >
      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}>
        {/* VIDEO SECTION */}
        <Box
          sx={{
            flex: { xs: "unset", md: 3 },
            backgroundColor: "#000",
            position: "relative",
            minHeight: { xs: 180, md: 430 },
            cursor: playVideo ? "default" : "pointer",
          }}
        >
          {!playVideo ? (
            <>
              <Box
                component="img"
                src={YoutubeThubmnail}
                alt="Program Preview"
                sx={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(to right, rgba(0,0,0,0.45), rgba(0,0,0,0.25))",
                }}
              />
              <Box
                onClick={() => setPlayVideo(true)}
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 2,
                }}
              >
                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #6a3df0, #8b5cf6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
                    transition: "transform 0.3s ease",
                    "&:hover": { transform: "scale(1.08)" },
                  }}
                >
                  <PlayArrowIcon sx={{ fontSize: 42, color: "#fff", ml: 0.5 }} />
                </Box>
              </Box>
            </>
          ) : (
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/Fo3zKRdfF-w?autoplay=1"
              title="Program Overview"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{ position: "absolute", inset: 0 }}
            />
          )}
        </Box>

        {/* FORM SECTION */}
        <Box
          sx={{
            flex: { xs: "unset", md: 2 },
            p: { xs: 3, md: 4 },
            background: "linear-gradient(180deg, #faf5ff, #ffffff)",
            position: "relative",
          }}
        >
          <IconButton onClick={onClose} sx={{ position: "absolute", top: 12, right: 12 }} aria-label="Close Free Consultation Form">
            <CloseIcon />
          </IconButton>

          <Typography variant="h5" fontWeight={700} mb={1} sx={{ fontFamily: "Poppins, sans-serif" }}>
            Get Program Details
          </Typography>

          <Typography fontSize={14} color="text.secondary" mb={3} sx={{ fontFamily: "Poppins, sans-serif" }}>
            Get a call back from our consultant within minutes.
          </Typography>

          <form
            id="webform774394000000902061"
            action="https://crm.zoho.in/crm/WebToLeadForm"
            name="WebToLeads774394000000902061"
            method="POST"
            onSubmit={handleFormSubmit}
            acceptCharset="UTF-8"
          >
            <input type="hidden" name="xnQsjsdp" defaultValue="4a4a99a77b8137a3700722754637141f25a725aed3bd74f7f2291552456e6e72" />
            <input type="hidden" name="xmIwtLD" defaultValue="4477b0113573944ded9f23798b21dcc503ed798c1e8d3d41e2eca16100c301411f1a9f1c89394993c158c84157a4ee3f" />
            <input type="hidden" name="actionType" defaultValue="TGVhZHM=" />
            <input type="hidden" name="returnURL" defaultValue="https://paperlive.in/thankyou" />
            <input type='hidden' id="zc_gad" name="zc_gad" value={gclid} />
            <input type="hidden" id="Website" name="Website" value={formValues.website} />
            <input type="hidden" id="Description" name="Description" value={formValues.description} />

            <TextField
              value={formValues.firstName}
              onChange={(e) => handleChange(e, "firstName")}
              label="First Name"
              id="First_Name"
              name="First Name"
              fullWidth
              sx={{ mt: 0, ...inputStyle }}
              InputProps={{ startAdornment: <InputAdornment position="start"><AssignmentIndIcon /></InputAdornment> }}
              error={!!errors.firstName}
            />

            <TextField
              value={formValues.lastName}
              onChange={(e) => handleChange(e, "lastName")}
              label="Last Name"
              id="Last_Name"
              name="Last Name"
              fullWidth
              sx={{ mt: 2, ...inputStyle }}
              InputProps={{ startAdornment: <InputAdornment position="start"><AssignmentIndIcon /></InputAdornment> }}
              error={!!errors.lastName}
            />

            <TextField
              value={formValues.email}
              onChange={(e) => handleChange(e, "email")}
              label="Email"
              type="email"
              id="Email"
              name="Email"
              fullWidth
              sx={{ mt: 2, ...inputStyle }}
              InputProps={{ startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment> }}
              error={!!errors.email}
            />

            <TextField
              value={formValues.phone}
              onChange={(e) => handleChange(e, "phone")}
              label="Phone"
              id="Phone"
              name="Phone"
              type="tel"
              fullWidth
              sx={{ mt: 2, ...inputStyle }}
              InputProps={{ startAdornment: <InputAdornment position="start"><PhoneIphoneIcon /></InputAdornment> }}
              error={!!errors.phone}
            />
            <Typography color="red" mt={1}>{formError}</Typography>

            <Button
              aria-label="Request Callback"
              fullWidth
              size="large"
              sx={{
                mt: 3,
                py: 1.4,
                fontWeight: 600,
                borderRadius: 2,
                background: "linear-gradient(90deg, #6a3df0, #8b5cf6)",
                "&:hover": {
                  background: "linear-gradient(90deg, #5b30e0, #7c4df0)",
                },
              }}
              variant="contained"
              onClick={handleFormSubmit}
            >
              Request Callback
            </Button>
          </form>
        </Box>
      </Box>
    </Dialog>
  );
}
